import React from 'react';

import { Button, Modal } from '../../index';
import EventForm from '../../forms/EventForm';
import { useFormModal } from '../../../hooks/useFormModal';

interface Props {
  title: string;
  className?: string;
}

const EventButton = ({ title, className }: Props) => {
  const { isOpen: enquireModal, openModal, closeModal } = useFormModal(['eventForm']);

  return (
    <>
      <Button onClick={openModal} className={className} type="solidOrange" large>
        Register for the event
      </Button>
      <Modal isOpen={enquireModal} onRequestClose={closeModal} title={title}>
        <EventForm eventName={title} />
      </Modal>
    </>
  );
};

export default EventButton;
